export const Data = [
  // {
  //   id: 1,
  //   image: Image1,
  //   profile: "https://www.linkedin.com/in/niteesh-putla/",
  //   title: "Ajeesh Ashokan - Founder of JAM ZtudioZ",
  //   description:
  //     "I have seen shubham grow from a beginner to a responsible person in his professional career. He is very adaptive in time of crisis and would like to highlight his self motivation to achieve his targets and also his keen interest in learning new things. Shubham can be a good asset for any organisation and the company can entrust him with responsibilities and be assured that the same is in safe hands.",
  // },
  {
    id: 2,
    image:
      "https://media.licdn.com/dms/image/v2/D5603AQGdewA2nAfMKg/profile-displayphoto-shrink_800_800/B56ZPAKXXIG8Ac-/0/1734095763497?e=1740009600&v=beta&t=xoAF1RUPpjK3mws9G9UDdE4YVaX7NflvZRgCbDVLEMo",
    profile: "https://www.linkedin.com/in/niteesh-putla/",
    title: "Niteesh Putla - Sr Software Engineeer at ideyalabs",
    description:
      "I have worked with Shubham for about 1.4 years. He is a dedicated, hardworking, and go-getter team player. He consistently exceeds expectations and isn't afraid to voice his opinions, making him a valuable asset to any team. I highly recommend him for any role that requires a motivated and results-oriented individual.",
  },
  {
    id: 3,
    image:
      "https://media.licdn.com/dms/image/v2/C5103AQEnqfoljP8ygQ/profile-displayphoto-shrink_800_800/profile-displayphoto-shrink_800_800/0/1562298841462?e=1740009600&v=beta&t=AzTyD9gxI5pO-2pE_29qn_ixuGpxoJ2X7k79tAhuzqY",
    profile: "https://www.linkedin.com/in/ashwini-karve-57400918b/",
    title: "Ashwini karve - Sr Software Engineeer at JAM ZtudioZ",
    description:
      "It was a pleasure to work with Shubham, we shared the same project in our organization, and whenever I got stuck with a problem in the project, he was always there to help out, Many other team members also ask him their doubts to him, He is holding excellent programming skills, His problem-solving approach is very good, and I am very happy because I worked with him.",
  },
  {
    id: 4,
    image:
      "https://media.licdn.com/dms/image/v2/D4D35AQHJq9EQN6O3QQ/profile-framedphoto-shrink_800_800/profile-framedphoto-shrink_800_800/0/1721887288157?e=1734872400&v=beta&t=c1DgS1-NGxk_irwkNCgDPri2-G3EEUk7jHrQ3KV7w6w",
    profile: "https://www.linkedin.com/in/akashdkshirsagar15/",
    title: "Akash Kshirsagar - Project Manager at JAM ZtudioZ",
    description:
      "I had the privilege of working alongside Shubham and I can confidently say that he is an exceptional colleague. His work ethic is second to none, always pushing to deliver his best work and constantly searching for new opportunities to improve. He is an expert at multitasking, with his ability to prioritize his workload and manage his time effectively. ",
  },
  {
    id: 5,
    image:
      "https://media.licdn.com/dms/image/v2/D5603AQF768vnAuF-tg/profile-displayphoto-shrink_400_400/B56ZNvB.Y0GcAg-/0/1732734609484?e=1740009600&v=beta&t=E-kGhyu8kCZl6FoSCqH10GBb_DLFN5ZAntgwIRjTROs",
    profile: "https://www.linkedin.com/in/shweta-pai-b97178171/",
    title: "Shweta Pai - Software Engineer at CitiusTech",
    description:
      "Shubham and I have been working in the same office. I have seen shubham working very hard and smartly. He was my senior, and being an intern he never made me feel like I am new in the office, he always had my back. He has excellent problem-solving skills through which he helped me rigorously. He is a confident and good human being.",
  },
];
